import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestService {
  constructor(public http: HttpClient) { }

  private request({url, method, body = {}, params = {$limit: '200'}, id = null}) {   
    const token = localStorage.getItem('@auth-token');
    const request = new HttpRequest(
      method, `${environment.apiUrl}/${url}/${id ? id : ''}`, body,{
        ...(token && {headers: new HttpHeaders({
          Authorization: `Bearer ${token}`
        }), 
        params: new HttpParams({fromObject: params})})
      });


    return this.http.request(request).pipe(map((res: any) => res.body)).toPromise();
  }

  get(url, params = {}) {
    return this.request({url, method:'GET'})
  }

  post(url, body) {
    return this.request({url, method: 'POST', body})
  }

  patch(url, body, id) {
    return this.request({url, method: 'PATCH', body, id});
  }

  delete(url, id) {
    return this.request({url, method: 'DELETE', id})
  }
}
